var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 246 231",
    width: 246,
    height: 231,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m129.4 214.7q13.5 0 26.9 0c18.8 0 37.5 0 56.3 0 1.7 0 3.5 0.1 5.1 0.7 3.4 1.3 5.1 4 4.8 7.6-0.3 3.5-2.2 5.9-5.6 6.7-1.7 0.4-3.5 0.4-5.2 0.4-31.4 0-62.7 0-94.1 0-20.5 0.1-41 0.2-61.5 0-2.3 0-5.2-1.2-6.9-2.9-12.1-11.8-23.9-23.8-35.8-35.8-17.2-17.2-17.2-40 0-57.1q60.4-60.5 120.9-120.9c17.5-17.6 40.1-17.6 57.7 0q19.9 19.9 39.7 39.8c17.7 17.7 17.8 40.3 0.1 58q-49.8 49.8-99.7 99.6c-1 1-2.4 1.8-3.6 2.6q0.4 0.7 0.9 1.3zm13.9-36.9c0.8-0.7 1.5-1.3 2.2-2 25.3-25.4 50.7-50.7 76-76.1 10.9-10.9 10.8-24.2 0-35.1q-20.3-20.3-40.5-40.5c-11.3-11.3-24.3-11.3-35.6-0.1q-37.6 37.6-75.2 75.3c-1 0.9-1.9 1.9-2.7 2.8 25.3 25.3 50.4 50.4 75.8 75.7zm-87.4-64.5c-10.6 10.7-21.4 21.5-32.1 32.3-10.5 10.6-10.5 23.9 0 34.5 10.7 10.8 21.5 21.6 32.4 32.3 1.3 1.3 3.6 2.2 5.5 2.2 10 0.2 20 0.1 30 0.1 5 0 10.5 1.2 14.8-0.6 4.2-1.7 7.1-6.5 10.6-9.9 5-5 10-10 14.9-14.9-25.5-25.4-50.5-50.5-76.1-76z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.c826caf0583541835e933733f4c46abe.svg";
export { ForwardRef as ReactComponent };